import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalComponent } from 'src/app/global-component';
import {
  ExtendedBaseInterface,
  ISearchRequest,
} from 'src/app/store/Authentication/auth.models';
import {
  CreateOffMarketProperty,
  DocumentUploadResponse,
  OffMarketProperty,
} from 'src/app/store/off-market-properties/off-market-properties.model';
import { environment } from 'src/environments/environment';

const env = environment.API_URL;

@Injectable({ providedIn: 'root' })
export class OffMarketPropertiesService {
  constructor(private http: HttpClient) {}

  getAdminOffMarketProperties(data: ISearchRequest) {
    return this.http.get<ExtendedBaseInterface>(
      `${env}OffMarketProperties/List?PageNumber=${data.PageNumber}&PageSize=${data.PageSize}&SortColumn=${data.SortColumn}&SortOrder=${data.SortOrder}&Search=${data.Search}`
    );
  }

  getAdminOffMarketPropertyDetails(id: number) {
    return this.http.get<OffMarketProperty>(
      `${env}OffMarketProperties/GetOffMarket?id=${id}`
    );
  }

  createAdminOffMarketProperty(data: CreateOffMarketProperty) {
    return this.http.post<OffMarketProperty>(
      `${env}OffMarketProperties/CreateOffMarket`,
      data
    );
  }

  updateAdminOffMarketProperty(data: OffMarketProperty) {
    return this.http.put<OffMarketProperty>(
      `${env}OffMarketProperties/UpdateOffMarket`,
      data
    );
  }

  deleteAdminOffMarketProperty(id: number) {
    return this.http.delete<ExtendedBaseInterface>(
      `${env}OffMarketProperties/DeleteOffMarket?id=${id}`
    );
  }

  uploadAdminOffMarketPropertyDocuments(data: {
    file: File;
    order: number;
    propertyId: number;
  }) {
    const formData = new FormData();
    formData.append('File', data.file, data.file.name);
    formData.append('Order', data.order.toString());
    return this.http.post<DocumentUploadResponse>(
      `${env}OffMarketProperties/UploadImage?propertyId=${data.propertyId}`,
      formData
    );
  }

  deleteAdminOffMarketPropertyDocument(data: {
    propertyId: number;
    imageId: number;
  }) {
    return this.http.delete<ExtendedBaseInterface>(
      `${env}OffMarketProperties/DeleteImage?propertyId=${data.propertyId}&imageId=${data.imageId}`
    );
  }

  generateAdminOffMarketPropertyShareLink(propertyId: number) {
    return this.http.post<{
      token: string;
      createdAtUtc: string;
      expiresAtUtc: string;
      isRevoked: boolean;
    }>(
      `${env}OffMarketProperties/GenerateShareLink?propertyId=${propertyId}`,
      ''
    );
  }
}
